import { render, staticRenderFns } from "./unlock.vue?vue&type=template&id=3054fc04&"
import script from "./unlock.vue?vue&type=script&lang=ts&"
export * from "./unlock.vue?vue&type=script&lang=ts&"
import style0 from "./unlock.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports